import styled from 'styled-components'

export const TabListContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-right: 1rem;
    div[role='tablist'] {
        overflow: hidden;
        overflow-x: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */

        &::-webkit-scrollbar {
            /* WebKit */
            width: 0;
            height: 0;
        }
    }
`
